import * as React from 'react';

import theme from '../Theme/index';
import { VALID_EDGE_STYLE_DATA, VALID_MEDIA_STYLES } from '../Utils';

import { IBannerCommonProps, VALID_BANNER_VARIANTS } from './common';
import StyledBanner from './StyledBanner';

const variants = Object.keys(theme.banner);

export type VALID_BANNER_TYPES = VALID_BANNER_VARIANTS | 'info';

interface IBannerProps extends IBannerCommonProps {
  margin?: VALID_EDGE_STYLE_DATA;
  order?: VALID_MEDIA_STYLES;
}

type IAccumulator = Record<VALID_BANNER_TYPES, React.FC<React.HTMLAttributes<HTMLElement> & IBannerProps>>;

const makeBannerVariant = (variant: string): React.FC<React.HTMLAttributes<HTMLElement> & IBannerProps> => ({
  alignSelf,
  flexBasis,
  flexGrow,
  flexShrink,
  children,
  margin,
  order,
  ...rest
}) => (
  <StyledBanner
    {...rest}
    alignSelf={alignSelf}
    flexBasis={flexBasis}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    marginProp={margin}
    orderProp={order}
    variant={variant}
  >
    {children}
  </StyledBanner>
);

const Banners: Record<VALID_BANNER_TYPES, React.FC<React.HTMLAttributes<HTMLElement> & IBannerProps>> =
  variants.reduce(
    (acc, v) => ({
      ...acc,
      [v]: makeBannerVariant(v),
    }),
    // tslint:disable-next-line:no-object-literal-type-assertion
    {} as IAccumulator
  );

export default Banners;

// stylguidist requires a react component to be exported to generate a place in the styleguide
export const Banner: React.FC = () => <>dummy</>;
